import React from "react";

import { Typography } from "@mui/material";
import { Divider, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Badge } from "reactstrap";

import { Comment } from "../../../../models/comment";
import { Button } from "../../../Form";
import CommentHistoryItem from "./Item";
import useStyles from "./styles";

export interface Props {
  comments?: Comment[];
  count?: number;
  hasMore?: boolean;
  isLoading?: boolean;
  onLoadMore: () => void;
  onDeleteComment?: (data: Comment) => void;
  hasPermission?: boolean;
}

const CommentHistory = ({
  comments = [],
  count = 0,
  hasMore = false,
  isLoading = false,
  onLoadMore,
  onDeleteComment,
  hasPermission = true,
}: Props) => {
  const classes = useStyles();
  const { t: translate } = useTranslation();

  if (!comments.length) return null;

  return (
    <div className={classes.content}>
      <div className={classes.headline}>
        <Typography className={classes.headlineText}>{translate("commentHistory")}</Typography>
        <Badge className={classes.headlineBadge}>{count}</Badge>
      </div>

      <div className={classes.commentList}>
        <Stack divider={<Divider flexItem orientation="horizontal" />} width="100%">
          {comments.map((comment) => (
            <CommentHistoryItem
              key={`comment-${comment.id}`}
              comment={comment}
              hasPermission={hasPermission}
              onDeleteComment={onDeleteComment}
            />
          ))}
        </Stack>

        {hasMore && (
          <div className={classes.loadMoreButtonContainer}>
            <Button disabled={isLoading} onClick={onLoadMore}>
              {translate("loadMore")}...
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default CommentHistory;
